import { faBadgeCheck } from '~/assets';
import { SceneWrapper } from '~/components';
import { observer } from '~/modules';
import { Description, IconComponent, Title } from './styles';

const CreditSimulationConfirmation = () => {
  return (
    <SceneWrapper>
      <IconComponent icon={faBadgeCheck} />
      <Title>Pedido realizado com sucesso. Aguarde o processamento.</Title>
      <Description>
        Para realizar o saque, dirija-se a uma farmácia São João durante o
        horário comercial. O saque está sujeito à disponibilidade de recursos no
        caixa.
      </Description>
    </SceneWrapper>
  );
};

export default observer(CreditSimulationConfirmation);
